import { NgModule } from '@angular/core';
import { MessengerService } from 'src/app/components/event-messenger/services/messenger.service';
import { ChatEngineActiveChannelService } from '../../interfaces/chat-engine/chat-engine-active-channel.service';
import { ChatEngineChannelsService } from '../../interfaces/chat-engine/chat-engine-channels.service';
import { ChatEngineErrorService } from '../../interfaces/chat-engine/chat-engine-error.service';
import { ChatEngineLifeСycleService } from '../../interfaces/chat-engine/chat-engine-lifecycle-service';
import { ChatEngineNotificationChannelService } from '../../interfaces/chat-engine/chat-engine-notification-channel.service';
import { ChatEngineSendMessageService } from '../../interfaces/chat-engine/chat-engine-send-message.service';
import { TwilioActiveChannelService } from './twilio-active-channel.service';
import { TwilioChannelsService } from './twilio-channels.service';
import { TwilioClientAccessService } from './twilio-client-access-service';
import { TwilioEngineLifecycleService } from './twilio-engine-lifecycle.service';
import { TwilioErrorService } from './twilio-error.service';
import { TwilioMessengerService } from './twilio-messenger.service';
import { TwilioNotificationChannelService } from './twilio-notification-channel.service';
import { TwilioSendMessageService } from './twilio-send-message.service';
import { TwilioUsersService } from './twilio-users.service';

@NgModule({
  providers: [
    TwilioActiveChannelService,
    TwilioChannelsService,
    TwilioMessengerService,
    TwilioEngineLifecycleService,
    TwilioErrorService,
    TwilioSendMessageService,
    TwilioUsersService,
    TwilioNotificationChannelService,
    {
      provide: ChatEngineActiveChannelService,
      useExisting: TwilioActiveChannelService,
    },
    {
      provide: ChatEngineNotificationChannelService,
      useExisting: TwilioNotificationChannelService,
    },
    {
      provide: ChatEngineChannelsService,
      useExisting: TwilioChannelsService,
    },
    {
      provide: ChatEngineErrorService,
      useExisting: TwilioErrorService,
    },
    {
      provide: ChatEngineLifeСycleService,
      useExisting: TwilioEngineLifecycleService,
    },
    {
      provide: ChatEngineSendMessageService,
      useExisting: TwilioSendMessageService,
    },
    {
      provide: MessengerService,
      useExisting: TwilioMessengerService,
    },
    {
      provide: TwilioClientAccessService,
      useExisting: TwilioEngineLifecycleService,
    },
  ],
})
export class TwilioChatEngineModule {}
